export enum SequenceEnum {
  SUBJECT = "subject",
  CHAPTER = "chapter",
  LESSON = "lesson",
  SKILL = "skill",
  SUBJECT_NOTE = "subject_note",
  LECTURE = "lecture",
  GRADE = "grade",
  FLASH_CARD = "flash_card",
  PLAN = "plan",
}
